export default __webpack_public_path__ + "static/media/02__o_2.a3f5099c.jpg";